/* Instagram-style highlight viewer: progress bars, tap left/right, hold to pause,
   swipe down to close, keyboard arrows/Escape. Highlights without media open on Instagram. */
class IceStories extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('.ice-stories__modal');
    this.stage = this.querySelector('[data-stage]');
    this.bars = this.querySelector('.ice-stories__bars');
    this.name = this.querySelector('.ice-stories__who-name');
    this.muteBtn = this.querySelector('[data-mute]');
    this.muted = true;
    this.labelUnmute = this.dataset.labelUnmute || 'Activer le son';
    this.labelMute = this.dataset.labelMute || 'Couper le son';
    this.IMAGE_MS = 5000;

    this.querySelectorAll('.ice-stories__thumb').forEach((btn) =>
      btn.addEventListener('click', () => this.open(btn))
    );
    this.querySelector('[data-close]').addEventListener('click', () => this.close());
    this.querySelector('[data-prev]').addEventListener('click', (e) => { e.stopPropagation(); this.prev(); });
    this.querySelector('[data-next]').addEventListener('click', (e) => { e.stopPropagation(); this.next(); });
    this.muteBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.muted = !this.muted;
      this.modal.classList.toggle('is-sound', !this.muted);
      this.muteBtn.setAttribute('aria-label', this.muted ? this.labelUnmute : this.labelMute);
      const v = this.stage.querySelector('video');
      if (v) v.muted = this.muted;
    });

    // Tap halves, hold to pause, swipe.
    let downAt = 0, x0 = 0, y0 = 0;
    this.stage.addEventListener('pointerdown', (e) => {
      downAt = Date.now(); x0 = e.clientX; y0 = e.clientY;
      this.pause(true);
    });
    this.stage.addEventListener('pointerup', (e) => {
      const dx = e.clientX - x0, dy = e.clientY - y0, held = Date.now() - downAt;
      this.pause(false);
      if (dy > 90) return this.close();
      if (Math.abs(dx) > 50) return dx < 0 ? this.next() : this.prev();
      if (held < 250) {
        const r = this.stage.getBoundingClientRect();
        e.clientX - r.left < r.width / 2 ? this.prev() : this.next();
      }
    });
    this.stage.addEventListener('pointerleave', () => this.pause(false));
    this.onKey = (e) => {
      if (this.modal.hidden) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowRight') this.next();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === ' ') { e.preventDefault(); this.pause(!this.paused); }
    };
    document.addEventListener('keydown', this.onKey);
  }

  open(btn) {
    const items = (btn.dataset.items || '').split('~').filter(Boolean).map((s) => {
      const [type, src] = s.split('|');
      return { type, src };
    });
    if (!items.length) {
      window.open(btn.dataset.link, '_blank', 'noopener');
      return;
    }
    this.thumb = btn;
    this.items = items;
    this.name.textContent = btn.dataset.title;
    this.bars.innerHTML = items.map(() => '<span><i></i></span>').join('');
    this.modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => this.modal.classList.add('is-open'));
    this.show(0);
  }

  close() {
    this.stop();
    this.modal.classList.remove('is-open');
    this.modal.hidden = true;
    this.stage.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (this.thumb) { this.thumb.classList.add('is-seen'); this.thumb.focus(); }
  }

  show(i) {
    this.stop();
    this.index = i;
    [...this.bars.children].forEach((b, n) => {
      b.firstElementChild.style.width = n < i ? '100%' : '0%';
    });
    const item = this.items[i];
    this.muteBtn.hidden = item.type !== 'video';
    let el;
    if (item.type === 'video') {
      el = document.createElement('video');
      el.src = item.src;
      el.playsInline = true;
      el.muted = this.muted;
      el.autoplay = true;
      el.addEventListener('ended', () => this.next());
      el.addEventListener('timeupdate', () => {
        if (el.duration) this.setProgress(el.currentTime / el.duration);
      });
    } else {
      el = document.createElement('img');
      el.src = item.src;
      el.alt = '';
      el.addEventListener('load', () => this.runTimer(), { once: true });
    }
    el.className = 'ice-stories__media';
    this.stage.replaceChildren(el);
    if (item.type === 'video') el.play().catch(() => {});
  }

  runTimer() {
    this.elapsed = 0;
    this.last = performance.now();
    const tick = (now) => {
      if (!this.paused) this.elapsed += now - this.last;
      this.last = now;
      const p = Math.min(this.elapsed / this.IMAGE_MS, 1);
      this.setProgress(p);
      if (p >= 1) return this.next();
      this.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  }

  setProgress(p) {
    const bar = this.bars.children[this.index];
    if (bar) bar.firstElementChild.style.width = `${p * 100}%`;
  }

  pause(on) {
    this.paused = on;
    this.modal.classList.toggle('is-paused', on);
    const v = this.stage.querySelector('video');
    if (v) on ? v.pause() : v.play().catch(() => {});
  }

  stop() {
    cancelAnimationFrame(this.raf);
    this.paused = false;
  }

  next() {
    this.index < this.items.length - 1 ? this.show(this.index + 1) : this.close();
  }

  prev() {
    this.show(Math.max(this.index - 1, 0));
  }
}

if (!customElements.get('ice-stories')) customElements.define('ice-stories', IceStories);
